import { render, staticRenderFns } from "./ActionAcceptIntroduce.vue?vue&type=template&id=13051c20&scoped=true"
import script from "./ActionAcceptIntroduce.vue?vue&type=script&lang=js"
export * from "./ActionAcceptIntroduce.vue?vue&type=script&lang=js"
import style0 from "./ActionAcceptIntroduce.vue?vue&type=style&index=0&id=13051c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13051c20",
  null
  
)

export default component.exports